import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'

// Layouts
const DefaultLayout = () => import('../layouts/DefaultLayout.vue')

// Views - Auth
const Login = () => import('../views/auth/Login.vue')
const ForgotPassword = () => import('../views/auth/ForgotPassword.vue')
const ResetPassword = () => import('../views/auth/ResetPassword.vue')

// Views - Dashboard
const Dashboard = () => import('../views/Dashboard.vue')

// Views - Afiliados
const Afiliados = () => import('../views/afiliados/Afiliados.vue')
const AfiliadoForm = () => import('../views/afiliados/AfiliadoForm.vue')

// Views - Organizaciones
const Organizaciones = () => import('../views/organizaciones/Organizaciones.vue')
const OrganizacionForm = () => import('../views/organizaciones/OrganizacionForm.vue')

// Views - Federaciones
const Federaciones = () => import('../views/federaciones/Federaciones.vue')
const FederacionForm = () => import('../views/federaciones/FederacionForm.vue')

// Views - Empresas
const Empresas = () => import('../views/empresas/Empresas.vue')
const EmpresaForm = () => import('../views/empresas/EmpresaForm.vue')

// Views - Entidades Financieras
const EntidadesFinancieras = () => import('../views/entidades-financieras/EntidadesFinancieras.vue')
const EntidadFinancieraForm = () => import('../views/entidades-financieras/EntidadFinancieraForm.vue')

// Views - Funciones Sindicales
const FuncionesSindicales = () => import('../views/funcionesSindicales/FuncionesSindicales.vue')
const FuncionSindicalForm = () => import('../views/funcionesSindicales/FuncionSindicalForm.vue')

// Views - Centros de Trabajo
const CentrosTrabajo = () => import('../views/centrosTrabajo/CentrosTrabajo.vue')
const CentroTrabajoForm = () => import('../views/centrosTrabajo/CentroTrabajoForm.vue')

// Views - Factorias
const Factorias = () => import('../views/factorias/Factorias.vue')
const FactoriaForm = () => import('../views/factorias/FactoriaForm.vue')

// Views - Tipos de Cobro de Cuota
const TiposCobroCuota = () => import('../views/tiposCobroCuota/TiposCobroCuota.vue')
const TipoCobroCuotaForm = () => import('../views/tiposCobroCuota/TipoCobroCuotaForm.vue')

// Views - Usuarios
const Usuarios = () => import('../views/usuarios/Usuarios.vue')
const UsuarioForm = () => import('../views/usuarios/UsuarioForm.vue')

// Views - Perfil
const Perfil = () => import('../views/perfil/Perfil.vue')

const routes = [
  {
    path: '/',
    name: 'Home',
    component: DefaultLayout,
    redirect: '/dashboard',
    meta: { requiresAuth: true },
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard
      },
      {
        path: '/afiliados',
        name: 'Afiliados',
        component: Afiliados
      },
      {
        path: '/afiliados/nuevo',
        name: 'NuevoAfiliado',
        component: AfiliadoForm
      },
      {
        path: '/afiliados/:id',
        name: 'EditarAfiliado',
        component: AfiliadoForm,
        props: true
      },
      {
        path: '/organizaciones',
        name: 'Organizaciones',
        component: Organizaciones
      },
      {
        path: '/organizaciones/nueva',
        name: 'NuevaOrganizacion',
        component: OrganizacionForm
      },
      {
        path: '/organizaciones/:id',
        name: 'EditarOrganizacion',
        component: OrganizacionForm,
        props: true
      },
      {
        path: '/federaciones',
        name: 'Federaciones',
        component: Federaciones
      },
      {
        path: '/federaciones/nueva',
        name: 'NuevaFederacion',
        component: FederacionForm
      },
      {
        path: '/federaciones/:id',
        name: 'EditarFederacion',
        component: FederacionForm,
        props: true
      },
      {
        path: '/empresas',
        name: 'Empresas',
        component: Empresas
      },
      {
        path: '/empresas/nueva',
        name: 'NuevaEmpresa',
        component: EmpresaForm
      },
      {
        path: '/empresas/:id',
        name: 'EditarEmpresa',
        component: EmpresaForm,
        props: true
      },
      {
        path: '/usuarios',
        name: 'Usuarios',
        component: Usuarios
      },
      {
        path: '/usuarios/nuevo',
        name: 'NuevoUsuario',
        component: UsuarioForm
      },
      {
        path: '/usuarios/:id',
        name: 'EditarUsuario',
        component: UsuarioForm,
        props: true
      },
      {
        path: '/perfil',
        name: 'Perfil',
        component: Perfil
      },
      {
        path: '/configuraciones',
        name: 'Configuraciones',
        component: () => import('../views/configuraciones/Configuraciones.vue')
      },
      {
        path: '/entidades-financieras',
        name: 'EntidadesFinancieras',
        component: EntidadesFinancieras
      },
      {
        path: '/entidades-financieras/nuevo',
        name: 'NuevaEntidadFinanciera',
        component: EntidadFinancieraForm
      },
      {
        path: '/entidades-financieras/:id',
        name: 'EditarEntidadFinanciera',
        component: EntidadFinancieraForm,
        props: true
      },
      {
        path: '/entidades-financieras-simple',
        name: 'EntidadesFinancierasSimple',
        component: () => import('../views/entidades-financieras/EntidadesFinancierasSimple.vue')
      },
      {
        path: '/entidades-financieras-test',
        name: 'EntidadesFinancierasTest',
        component: () => import('../views/entidades-financieras/EntidadesFinancierasTest.vue')
      },
      // Rutas para Funciones Sindicales
      {
        path: '/funciones-sindicales',
        name: 'FuncionesSindicales',
        component: FuncionesSindicales
      },
      {
        path: '/funciones-sindicales/nuevo',
        name: 'NuevaFuncionSindical',
        component: FuncionSindicalForm
      },
      {
        path: '/funciones-sindicales/:id',
        name: 'EditarFuncionSindical',
        component: FuncionSindicalForm,
        props: true
      },
      // Rutas para Centros de Trabajo
      {
        path: '/centros-trabajo',
        name: 'CentrosTrabajo',
        component: CentrosTrabajo
      },
      {
        path: '/centros-trabajo/nuevo',
        name: 'NuevoCentroTrabajo',
        component: CentroTrabajoForm
      },
      {
        path: '/centros-trabajo/:id',
        name: 'EditarCentroTrabajo',
        component: CentroTrabajoForm,
        props: true
      },
      // Rutas para Factorias
      {
        path: '/factorias',
        name: 'Factorias',
        component: Factorias
      },
      {
        path: '/factorias/nuevo',
        name: 'NuevaFactoria',
        component: FactoriaForm
      },
      {
        path: '/factorias/:id',
        name: 'EditarFactoria',
        component: FactoriaForm,
        props: true
      },
      // Rutas para Tipos de Cobro de Cuota
      {
        path: '/tipos-cobro-cuota',
        name: 'TiposCobroCuota',
        component: TiposCobroCuota
      },
      {
        path: '/tipos-cobro-cuota/nuevo',
        name: 'NuevoTipoCobroCuota',
        component: TipoCobroCuotaForm
      },
      {
        path: '/tipos-cobro-cuota/:id',
        name: 'EditarTipoCobroCuota',
        component: TipoCobroCuotaForm,
        props: true
      },
      // Rutas para Territoriales
      {
        path: '/territoriales',
        name: 'Territoriales',
        component: () => import('../views/territoriales/Territoriales.vue')
      },
      {
        path: '/territoriales/nuevo',
        name: 'NuevaTerritorial',
        component: () => import('../views/territoriales/TerritorialForm.vue')
      },
      {
        path: '/territoriales/:id',
        name: 'EditarTerritorial',
        component: () => import('../views/territoriales/TerritorialForm.vue'),
        props: true
      },
      // Rutas para Provincias
      {
        path: '/provincias',
        name: 'Provincias',
        component: () => import('../views/provincias/Provincias.vue')
      },
      {
        path: '/provincias/nuevo',
        name: 'NuevaProvincia',
        component: () => import('../views/provincias/ProvinciaForm.vue')
      },
      {
        path: '/provincias/:id',
        name: 'EditarProvincia',
        component: () => import('../views/provincias/ProvinciaForm.vue'),
        props: true
      },
      // Rutas para Municipios
      {
        path: '/municipios',
        name: 'Municipios',
        component: () => import('../views/municipios/Municipios.vue')
      },
      {
        path: '/municipios/nuevo',
        name: 'NuevoMunicipio',
        component: () => import('../views/municipios/MunicipioForm.vue')
      },
      {
        path: '/municipios/:id',
        name: 'EditarMunicipio',
        component: () => import('../views/municipios/MunicipioForm.vue'),
        props: true
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/reset-password/:token',
    name: 'ResetPassword',
    component: ResetPassword,
    props: true
  },
  {
    path: '/wallet/:id',
    name: 'WalletRedirect',
    component: () => import('../views/wallet/WalletRedirect.vue'),
    props: true
  },
  {
    path: '/download/:hash',
    name: 'WalletDownload',
    component: () => import('../views/wallet/WalletDownload.vue'),
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = store.getters['auth/isAuthenticated']
  const token = localStorage.getItem('token')
  
  console.log('Router guard:', {
    to: to.path,
    from: from.path,
    requiresAuth,
    isAuthenticated,
    hasToken: !!token
  })

  if (requiresAuth && !isAuthenticated) {
    console.log('Redirecting to login - not authenticated')
    next('/login')
  } else if (to.path === '/login' && isAuthenticated) {
    console.log('Redirecting to dashboard - already authenticated')
    next('/dashboard')
  } else {
    next()
  }
})

export default router